import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000",
    "col2n": "#9C3AFF"
}
function ObjMor106({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <linearGradient
                    id="ObjMor106__Gradient_1"
                    gradientUnits="userSpaceOnUse"
                    x1={288.425}
                    y1={99.7}
                    x2={289.475}
                    y2={98.5}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_2"
                    gradientUnits="userSpaceOnUse"
                    x1={287.95}
                    y1={100.125}
                    x2={286.75}
                    y2={101.175}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_3"
                    gradientUnits="userSpaceOnUse"
                    x1={290.775}
                    y1={99.6}
                    x2={289.725}
                    y2={98.4}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_4"
                    gradientUnits="userSpaceOnUse"
                    x1={291.25}
                    y1={100.075}
                    x2={292.45}
                    y2={101.125}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_5"
                    gradientUnits="userSpaceOnUse"
                    x1={291.275}
                    y1={103.45}
                    x2={290.225}
                    y2={104.65}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_6"
                    gradientUnits="userSpaceOnUse"
                    x1={291.7}
                    y1={103.025}
                    x2={292.9}
                    y2={101.975}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_7"
                    gradientUnits="userSpaceOnUse"
                    x1={287.4}
                    y1={103.025}
                    x2={286.2}
                    y2={101.975}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_8"
                    gradientUnits="userSpaceOnUse"
                    x1={287.875}
                    y1={103.5}
                    x2={288.925}
                    y2={104.7}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_10"
                    gradientUnits="userSpaceOnUse"
                    x1={289.75}
                    y1={99.05}
                    x2={291.35}
                    y2={98.95}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_11"
                    gradientUnits="userSpaceOnUse"
                    x1={289.15}
                    y1={99.05}
                    x2={287.55}
                    y2={98.95}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_12"
                    gradientUnits="userSpaceOnUse"
                    x1={291.5}
                    y1={100.7}
                    x2={291.6}
                    y2={99.1}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_13"
                    gradientUnits="userSpaceOnUse"
                    x1={291.5}
                    y1={101.35}
                    x2={291.6}
                    y2={102.95}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_14"
                    gradientUnits="userSpaceOnUse"
                    x1={289.75}
                    y1={103.75}
                    x2={291.35}
                    y2={103.85}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_15"
                    gradientUnits="userSpaceOnUse"
                    x1={289.15}
                    y1={103.75}
                    x2={287.55}
                    y2={103.85}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_16"
                    gradientUnits="userSpaceOnUse"
                    x1={286.7}
                    y1={100.8}
                    x2={286.6}
                    y2={99.2}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_17"
                    gradientUnits="userSpaceOnUse"
                    x1={286.7}
                    y1={101.4}
                    x2={286.6}
                    y2={103}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_19"
                    gradientUnits="userSpaceOnUse"
                    x1={344.025}
                    y1={20.325}
                    x2={342.675}
                    y2={21.075}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_20"
                    gradientUnits="userSpaceOnUse"
                    x1={344.537}
                    y1={20.025}
                    x2={345.762}
                    y2={19.075}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_21"
                    gradientUnits="userSpaceOnUse"
                    x1={346.825}
                    y1={20.375}
                    x2={346.075}
                    y2={19.025}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_22"
                    gradientUnits="userSpaceOnUse"
                    x1={347.175}
                    y1={20.837}
                    x2={348.125}
                    y2={22.063}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_23"
                    gradientUnits="userSpaceOnUse"
                    x1={346.613}
                    y1={24.125}
                    x2={345.387}
                    y2={25.075}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_24"
                    gradientUnits="userSpaceOnUse"
                    x1={347.075}
                    y1={23.775}
                    x2={348.425}
                    y2={23.025}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_25"
                    gradientUnits="userSpaceOnUse"
                    x1={342.975}
                    y1={23.012}
                    x2={342.025}
                    y2={21.787}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_26"
                    gradientUnits="userSpaceOnUse"
                    x1={343.375}
                    y1={23.525}
                    x2={344.125}
                    y2={24.875}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_28"
                    gradientUnits="userSpaceOnUse"
                    x1={345.35}
                    y1={19.5}
                    x2={343.85}
                    y2={19.1}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_29"
                    gradientUnits="userSpaceOnUse"
                    x1={345.925}
                    y1={19.625}
                    x2={347.475}
                    y2={19.775}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_30"
                    gradientUnits="userSpaceOnUse"
                    x1={347.3}
                    y1={21.5}
                    x2={347.7}
                    y2={20}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_31"
                    gradientUnits="userSpaceOnUse"
                    x1={347.225}
                    y1={22.125}
                    x2={347.075}
                    y2={23.675}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_32"
                    gradientUnits="userSpaceOnUse"
                    x1={344.525}
                    y1={24.025}
                    x2={342.975}
                    y2={23.875}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_33"
                    gradientUnits="userSpaceOnUse"
                    x1={345.1}
                    y1={24.15}
                    x2={346.6}
                    y2={24.55}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_34"
                    gradientUnits="userSpaceOnUse"
                    x1={342.725}
                    y1={20.675}
                    x2={342.875}
                    y2={19.125}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_35"
                    gradientUnits="userSpaceOnUse"
                    x1={342.6}
                    y1={21.3}
                    x2={342.2}
                    y2={22.8}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_37"
                    gradientUnits="userSpaceOnUse"
                    x1={292.087}
                    y1={43.813}
                    x2={293.313}
                    y2={42.388}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_38"
                    gradientUnits="userSpaceOnUse"
                    x1={291.512}
                    y1={44.388}
                    x2={290.088}
                    y2={45.612}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_39"
                    gradientUnits="userSpaceOnUse"
                    x1={294.913}
                    y1={43.712}
                    x2={293.688}
                    y2={42.288}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_40"
                    gradientUnits="userSpaceOnUse"
                    x1={295.438}
                    y1={44.238}
                    x2={296.862}
                    y2={45.462}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_41"
                    gradientUnits="userSpaceOnUse"
                    x1={296.038}
                    y1={47.712}
                    x2={297.462}
                    y2={46.488}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_42"
                    gradientUnits="userSpaceOnUse"
                    x1={295.512}
                    y1={48.238}
                    x2={294.287}
                    y2={49.663}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_43"
                    gradientUnits="userSpaceOnUse"
                    x1={290.912}
                    y1={47.662}
                    x2={289.488}
                    y2={46.438}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_44"
                    gradientUnits="userSpaceOnUse"
                    x1={291.488}
                    y1={48.238}
                    x2={292.713}
                    y2={49.663}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_46"
                    gradientUnits="userSpaceOnUse"
                    x1={361.688}
                    y1={71.537}
                    x2={360.513}
                    y2={72.563}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_47"
                    gradientUnits="userSpaceOnUse"
                    x1={362.137}
                    y1={71.138}
                    x2={363.162}
                    y2={69.962}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_48"
                    gradientUnits="userSpaceOnUse"
                    x1={364.963}
                    y1={71.487}
                    x2={366.137}
                    y2={72.513}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_49"
                    gradientUnits="userSpaceOnUse"
                    x1={364.512}
                    y1={71.038}
                    x2={363.488}
                    y2={69.862}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_50"
                    gradientUnits="userSpaceOnUse"
                    x1={365.413}
                    y1={74.413}
                    x2={366.587}
                    y2={73.388}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_51"
                    gradientUnits="userSpaceOnUse"
                    x1={364.962}
                    y1={74.813}
                    x2={363.938}
                    y2={75.988}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_52"
                    gradientUnits="userSpaceOnUse"
                    x1={361.188}
                    y1={74.413}
                    x2={360.013}
                    y2={73.388}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_53"
                    gradientUnits="userSpaceOnUse"
                    x1={361.637}
                    y1={74.862}
                    x2={362.662}
                    y2={76.038}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_55"
                    gradientUnits="userSpaceOnUse"
                    x1={362.888}
                    y1={70.637}
                    x2={361.313}
                    y2={70.563}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_56"
                    gradientUnits="userSpaceOnUse"
                    x1={363.512}
                    y1={70.637}
                    x2={365.088}
                    y2={70.563}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_57"
                    gradientUnits="userSpaceOnUse"
                    x1={365.262}
                    y1={72.287}
                    x2={365.338}
                    y2={70.713}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_58"
                    gradientUnits="userSpaceOnUse"
                    x1={365.262}
                    y1={72.913}
                    x2={365.338}
                    y2={74.487}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_59"
                    gradientUnits="userSpaceOnUse"
                    x1={362.888}
                    y1={75.363}
                    x2={361.313}
                    y2={75.438}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_60"
                    gradientUnits="userSpaceOnUse"
                    x1={363.462}
                    y1={75.313}
                    x2={365.038}
                    y2={75.387}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_61"
                    gradientUnits="userSpaceOnUse"
                    x1={360.488}
                    y1={72.963}
                    x2={360.412}
                    y2={74.537}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_62"
                    gradientUnits="userSpaceOnUse"
                    x1={360.488}
                    y1={72.337}
                    x2={360.412}
                    y2={70.763}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_64"
                    gradientUnits="userSpaceOnUse"
                    x1={314.3}
                    y1={80.35}
                    x2={314.2}
                    y2={82.25}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_65"
                    gradientUnits="userSpaceOnUse"
                    x1={314.3}
                    y1={79.55}
                    x2={314.2}
                    y2={77.65}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_66"
                    gradientUnits="userSpaceOnUse"
                    x1={317.1}
                    y1={77.45}
                    x2={319}
                    y2={77.35}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_67"
                    gradientUnits="userSpaceOnUse"
                    x1={316.3}
                    y1={77.45}
                    x2={314.4}
                    y2={77.35}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_68"
                    gradientUnits="userSpaceOnUse"
                    x1={319.95}
                    y1={79.6}
                    x2={320.05}
                    y2={77.7}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_69"
                    gradientUnits="userSpaceOnUse"
                    x1={319.95}
                    y1={80.3}
                    x2={320.05}
                    y2={82.2}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_70"
                    gradientUnits="userSpaceOnUse"
                    x1={316.3}
                    y1={83.25}
                    x2={314.4}
                    y2={83.35}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_71"
                    gradientUnits="userSpaceOnUse"
                    x1={317.1}
                    y1={83.25}
                    x2={319}
                    y2={83.35}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_73"
                    gradientUnits="userSpaceOnUse"
                    x1={362.888}
                    y1={35.013}
                    x2={362.813}
                    y2={36.688}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_74"
                    gradientUnits="userSpaceOnUse"
                    x1={362.888}
                    y1={34.288}
                    x2={362.813}
                    y2={32.613}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_75"
                    gradientUnits="userSpaceOnUse"
                    x1={364.688}
                    y1={32.438}
                    x2={363.013}
                    y2={32.362}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_76"
                    gradientUnits="userSpaceOnUse"
                    x1={365.413}
                    y1={32.438}
                    x2={367.087}
                    y2={32.362}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_77"
                    gradientUnits="userSpaceOnUse"
                    x1={367.912}
                    y1={34.962}
                    x2={367.988}
                    y2={36.637}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_78"
                    gradientUnits="userSpaceOnUse"
                    x1={367.912}
                    y1={34.337}
                    x2={367.988}
                    y2={32.663}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_79"
                    gradientUnits="userSpaceOnUse"
                    x1={364.688}
                    y1={37.563}
                    x2={363.013}
                    y2={37.638}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <linearGradient
                    id="ObjMor106__Gradient_80"
                    gradientUnits="userSpaceOnUse"
                    x1={365.413}
                    y1={37.563}
                    x2={367.087}
                    y2={37.638}
                    spreadMethod="pad"
                >
                    <stop offset="0%" stopColor="#FFF" stopOpacity={0.8} />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </linearGradient>
                <g id="ObjMor106__Layer10_0_MEMBER_0_MEMBER_0_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_1)"
                        d="M278.55 89.1l-.6.6 11.75 11.75 1.6-1.65-7.2-5.15-5.55-5.55z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_2)"
                        d="M277.95 89.7l-.75.75 5.6 5.55 5.3 7 1.6-1.55-11.75-11.75z"
                    />
                </g>
                <g id="ObjMor106__Layer10_0_MEMBER_0_MEMBER_1_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_3)"
                        d="M301.4 89.6l-.75-.75-5.6 5.55-7.05 5.4 1.55 1.6 11.85-11.8z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_4)"
                        d="M296.4 95.8l5.6-5.55-.6-.65-11.85 11.8 1.65 1.6 5.2-7.2z"
                    />
                </g>
                <g id="ObjMor106__Layer10_0_MEMBER_0_MEMBER_2_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_5)"
                        d="M290.05 101.8l-1.6 1.6 7.15 5.15 5.55 5.65.65-.65-11.75-11.75z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_6)"
                        d="M291.65 100.2l-1.6 1.6 11.75 11.75.75-.75-5.55-5.6-5.35-7z"
                    />
                </g>
                <g id="ObjMor106__Layer10_0_MEMBER_0_MEMBER_3_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_7)"
                        d="M289.15 101.8l-1.55-1.6-5.25 7.25-5.6 5.6.55.6 11.85-11.85z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_8)"
                        d="M283.7 108.8l7.1-5.4-1.65-1.6-11.85 11.85.8.75 5.6-5.6z"
                    />
                </g>
                <g id="ObjMor106__Layer10_0_MEMBER_1_MEMBER_0_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_10)"
                        d="M290.3 92.45V84.6h-.85v16.6h2.3l-1.45-8.75z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_11)"
                        d="M289.45 84.6h-1.05v7.85l-1.15 8.75h2.2V84.6z"
                    />
                </g>
                <g id="ObjMor106__Layer10_0_MEMBER_1_MEMBER_1_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_12)"
                        d="M289.4 101.1h16.7l-.05-1.05h-7.85l-8.75-1.2-.05 2.25z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_13)"
                        d="M289.4 101.1v2.3l8.75-1.45h7.9l.05-.85h-16.7z"
                    />
                </g>
                <g id="ObjMor106__Layer10_0_MEMBER_1_MEMBER_2_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_14)"
                        d="M290.55 110.45l1.2-8.75h-2.25l-.05 16.6h1.1v-7.85z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_15)"
                        d="M289.5 101.7h-2.3l1.4 8.75v7.85h.85l.05-16.6z"
                    />
                </g>
                <g id="ObjMor106__Layer10_0_MEMBER_1_MEMBER_3_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_16)"
                        d="M280 100.2h-7.95v.9h16.8l.05-2.25-8.9 1.35z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_17)"
                        d="M288.85 103.4v-2.3h-16.8l.05 1.05h8l8.75 1.25z"
                    />
                </g>
                <g id="ObjMor106__Layer10_1_MEMBER_0_MEMBER_0_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_19)"
                        d="M336.35 8.5l-.85.55 4.35 6.35 3.85 7.75 1.75-1.25-9.1-13.4z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_20)"
                        d="M345.45 21.9l1.85-1.3-5.95-6.25-4.3-6.35-.7.5 9.1 13.4z"
                    />
                </g>
                <g id="ObjMor106__Layer10_1_MEMBER_0_MEMBER_1_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_21)"
                        d="M345.35 21.85l13.45-9.25-.6-.85-6.35 4.35-7.75 3.9 1.25 1.85z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_22)"
                        d="M345.35 21.85l1.3 1.85 6.25-6 6.35-4.35-.45-.75-13.45 9.25z"
                    />
                </g>
                <g id="ObjMor106__Layer10_1_MEMBER_0_MEMBER_2_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_23)"
                        d="M349.8 29.8l4.35 6.4.65-.5-9.05-13.4-1.85 1.25 5.9 6.25z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_24)"
                        d="M347.55 21l-1.8 1.3 9.05 13.4.9-.55-4.35-6.4-3.8-7.75z"
                    />
                </g>
                <g id="ObjMor106__Layer10_1_MEMBER_0_MEMBER_3_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_25)"
                        d="M337.4 26.35l-6.45 4.35.45.65 13.5-9.25-1.2-1.8-6.3 6.05z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_26)"
                        d="M346.15 23.95l-1.25-1.85-13.5 9.25.6.9 6.45-4.35 7.7-3.95z"
                    />
                </g>
                <g id="ObjMor106__Layer10_1_MEMBER_1_MEMBER_0_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_28)"
                        d="M345.25 21.6l3-16-.95-.15-1.4 7.6-2.75 8.15 2.1.4z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_29)"
                        d="M345.25 21.6l2.2.45.25-8.65 1.4-7.6-.85-.2-3 16z"
                    />
                </g>
                <g id="ObjMor106__Layer10_1_MEMBER_1_MEMBER_1_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_30)"
                        d="M345.3 21.5l15.95 3.05.1-1.05-7.5-1.45-8.15-2.7-.4 2.15z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_31)"
                        d="M345.3 21.5l-.45 2.2 8.6.2 7.6 1.45.2-.8-15.95-3.05z"
                    />
                </g>
                <g id="ObjMor106__Layer10_1_MEMBER_1_MEMBER_2_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_32)"
                        d="M342.8 30.3l-1.45 7.6.8.15 3.05-15.9-2.15-.45-.25 8.6z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_33)"
                        d="M347.4 22.55l-2.2-.4-3.05 15.9 1.1.2 1.45-7.6 2.7-8.1z"
                    />
                </g>
                <g id="ObjMor106__Layer10_1_MEMBER_1_MEMBER_3_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_34)"
                        d="M344.75 21.4l.45-2.15-8.75-.3-7.6-1.45-.15.85 16.05 3.05z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_35)"
                        d="M344.3 23.6l.45-2.2-16.05-3.05-.15 1 7.6 1.45 8.15 2.8z"
                    />
                </g>
                <g
                    id="ObjMor106__Symbol_271_0_Layer0_0_FILL"
                    fill={colors.col2n}
                >
                    <path d="M50 50.05V41.5q-5.85 0-11.65.1-.2 4.15-.2 8.45H50m26.45 41.6l-2.7.8q-3.2 2.95-6.7 4.95 4.95-2.2 9.4-5.75m-2.25-7.8q1.9-3.4 3.4-7.1-3.45.45-6.9.75-1.1 3.7-2.5 7.15 2.95-.35 6-.8m5.55.1q-2.45.4-4.95.8l-1.1 1.9q-2.1 3.2-4.3 5.8 1.9-.4 3.85-.95 2.55-2.4 4.9-5.45.85-1.05 1.6-2.1M51 94.45q2.7 0 5.4-.2 1.4-3.2 2.55-7.9-3.95.25-7.95.3v7.8m-9.3-9.05q4.15.2 8.3.25V78.4q-4.9-.05-9.8-.3.65 3.85 1.5 7.3m18.25.95q0 .05-.05.15-1.1 4.55-2.35 7.75 2.3-.25 4.6-.55 2.25-3.05 4.25-7.55.15-.2.25-.35-3.35.35-6.7.55m-.75-.95q.85-3.45 1.5-7.3-4.85.25-9.7.3v7.25q4.1-.05 8.2-.25m3.75-17.1l8.9-.4q.65-3.8 1-7.9-4.65.15-9.35.25-.2 4.15-.55 8.05m-1.05.05q.4-3.9.6-8.1l-11.5.1v8.15q5.45 0 10.9-.15m11-.55q3.75-.25 7.55-.5.8-3.7 1.25-7.6-3.95.15-7.9.25-.35 4.05-.9 7.85m-.2 1v.2q-.75 3.85-1.7 7.45 3.45-.3 7-.7 1.2-3.3 2.05-6.75.1-.35.15-.7l-7.5.5m.2-9.8v-.05q.25-3.8.3-7.9h-9.5q0 4.1-.15 7.9-.05.15-.05.3 4.75-.1 9.4-.25M39.05 69.3q.4 4.1 1 7.85 5 .2 9.95.25v-7.9q-5.5 0-10.95-.2m-.85 25.3q-1.8-.25-3.65-.6 3.35 3.15 7.15 4.9.8.35 1.6.6-.5-.25-.95-.6-2.15-1.7-4.15-4.3m-11.1-2.25q-1.5-.35-2.9-.8 4.7 3.85 10 6-3.7-2.05-7.1-5.2m-6-8.4l1.6 2.1q2.35 3.05 4.9 5.4 2.05.6 4.1 1-2.3-2.6-4.3-5.8-.6-.9-1.15-1.85-2.55-.4-5.15-.85m4.55-.2q-1.85-3.4-3.3-7.1-2.95-.35-6-.85 1.75 3.7 3.95 7 2.7.5 5.35.95M39.2 78.1q-3.95-.15-7.9-.55 1.1 3.8 2.55 7.2 3.45.4 6.8.65-.85-3.5-1.45-7.3M7.5 66.9q.3 1.1.65 2.1.9 2.45 2 4.8l4.6.8q-1.15-2.7-2-5.6-.25-.75-.45-1.5-2.4-.25-4.8-.6M5.8 74h-.1q1.8 3.3 4.15 6.45H10q1.65.45 3.4.85-2.2-3.2-3.9-6.6-1.85-.3-3.7-.7M4.15 51.05H0q.05 3.4.5 6.65 2.05.1 4.1.25-.4-3.35-.45-6.9m5.95 0H5.15Q5.2 54.6 5.6 58q2.45.15 4.95.3-.4-3.55-.45-7.25m8.25 8.65q-3.35-.2-6.7-.35.55 3.7 1.45 7.25 3.25.3 6.45.6-.8-3.6-1.2-7.5m2.5 8.6q.05.35.2.7.85 3.45 2.05 6.75 3.4.4 6.8.7-.95-3.6-1.65-7.45v-.15q-3.7-.25-7.4-.55m-.25-1q3.7.3 7.5.55-.65-3.8-1-7.85l-7.75-.3q.45 3.9 1.25 7.6m6.45-8.3v-.05q-.3-3.85-.3-7.9h-7.9q.05 3.95.4 7.65 3.45.2 6.8.25.55.05 1 .05m11.1-7.95q0 4.1.2 7.9v.35q5.8.05 11.65.05v-8.3H38.15M20.9 32.35q3.7-.4 7.4-.7.65-3.65 1.6-7.1-3.5.35-6.9.75-1.25 3.35-2.1 7.05m7.25.3q-3.75.3-7.5.7-.85 3.8-1.3 7.85l7.75-.3q.35-4.25 1.05-8.25m-17.6 10.1q-2.5.15-4.95.35-.45 3.4-.45 6.95h4.95q.05-3.75.45-7.3m-5.5-14.5h-.2q-1.05 2.3-1.95 4.7-.3.85-.55 1.75l-.05.05q0 .049-.05.05h.05q1.35-.25 2.75-.4.65-.1 1.35-.25.95-3.4 2.4-6.65-1.85.4-3.75.75m14.55 5.2q-3.25.3-6.5.75-.95 3.65-1.45 7.45 3.35-.2 6.7-.35.4-4.1 1.25-7.85M9.55 20.7q-.95 1.2-1.75 2.45-1.25 1.95-2.35 4 1.95-.4 3.85-.75.8-1.65 1.8-3.25.95-1.75 2.1-3.35-1.85.4-3.65.9M39 23.9q-4.05.2-8.1.55-.95 3.45-1.55 7.15 4.35-.35 8.75-.55.4-3.75.9-7.15m-16.7.5q.2-.65.45-1.25 1.25-3 2.7-5.8-2.65.45-5.35.9-1.55 2.35-2.8 4.9-.55 1-1 2.1 2.95-.5 6-.85m1.55-1.25q-.25.55-.45 1.1 3.35-.45 6.8-.7.05-.25.1-.4 1-3.5 2.35-6.8-2.95.35-5.95.8-1.6 2.9-2.85 6m2.25-6.9q.6-1.1 1.3-2.1 1.95-3.1 4.1-5.6-2.1.45-4.1.95-2.45 2.35-4.7 5.2-.95 1.2-1.8 2.4 2.6-.45 5.2-.85m-.65-6.2Q23.7 10.6 22 11.1q-1.85 1.65-3.6 3.65-1.55 1.7-2.9 3.5 2.05-.45 4-.85 1.15-1.65 2.4-3.3 1.7-2.2 3.55-4.05m1.3-4.45v.05q-.15.05-.35.15l-2 1.2q-1.55.9-3.05 2.05L19.5 10.4q-.5.45-1.05.9 1.5-.55 3.05-1.05 4.4-4 9.4-6.6-2.15.9-4.15 1.95m35.8 36q-5.8-.1-11.55-.1v8.55h11.7q0-4.3-.15-8.45M60.9 23.85q-4.95-.2-9.9-.25v7.25q5.4 0 10.8.15-.35-3.7-.9-7.15m10.9 8.7q-4.4-.35-8.9-.5.4 4.1.6 8.6 4.7.1 9.35.25-.35-4.3-1.05-8.35m8.6.8q-3.8-.45-7.6-.75.65 4.05 1 8.35 3.95.15 7.9.35-.4-4.1-1.3-7.95m-30.4-18q-4.2 0-8.35.25-.85 3.45-1.5 7.25 4.9-.25 9.85-.25v-7.25m-9.15-.7q.05-.2.05-.35 1.15-4.4 2.4-7.5-2.4.2-4.65.5-2.2 3-4.15 7.3l-.3.6q3.35-.35 6.65-.55M43.7 5.8Q45.25 2.25 47 .6q-4.1 1.3-7.5 5.65 2.1-.35 4.2-.45M53.9.55q1.7 1.7 3.3 5.3 2.15.15 4.3.45-3.55-4.5-7.6-5.75m2.65 6.2q-2.8-.2-5.55-.2v7.8q4.05 0 8 .25v-.05q-1.15-4.65-2.45-7.8m14.1 16.4l.1.4q3.45.3 6.95.75-.25-.6-.5-1.15-1.25-3.1-2.9-6-3-.45-6.05-.8 1.35 3.3 2.4 6.8m-8.95-.2q1.8.05 3.6.2 2.2.15 4.45.3l-.1-.3q-1.1-3.6-2.5-6.95-3.45-.35-6.85-.55.8 3.45 1.4 7.3m.1-21q3.55 2.05 6.75 5.5 1.75.3 3.55.75-4.85-4.15-10.3-6.25M68 8.3q-2.15-.45-4.35-.75 1.95 2.85 3.7 6.65.25.55.5 1.15 2.9.3 5.85.75-.4-.75-.85-1.45-2.3-3.6-4.85-6.35m6.1.35q1.4.4 2.85.8-4.7-3.8-9.9-6.1 3.65 2.15 7.05 5.3m8.05 41.4q0-3.95-.35-7.75-4-.2-7.95-.35.35 3.95.35 8.1h7.95m-.7 40.25q.25-.2.6-.45-.35.1-.6.25l-2.6.8q-4.05 3.6-8.55 6.15 1.55-.7 3.1-1.5 4.2-2.1 8.05-5.25M93.6 65.95q.9-3.4 1.5-6.95-2.5.15-4.9.3-.45 3.7-1.35 7.2 2.35-.3 4.75-.55m-3.05 7.9q1.6-3.35 2.7-6.9-2.3.3-4.65.55-1 3.7-2.5 7.1 2.25-.35 4.45-.75m4.75.15h-.15q-1.95.4-3.95.75-1.6 3.4-3.85 6.6l3.8-.9Q93.5 77.3 95.3 74m3.3-7.65h-.05q-2.1.2-4.2.5-1.05 3.5-2.6 6.8 1.95-.4 3.9-.75.15-.05.25-.05 1.6-3.2 2.7-6.5M95.2 58q.4-3.4.45-6.95h-4.9q0 3.7-.4 7.25 2.4-.15 4.85-.3m-4.95-16.25q2.45.2 4.85.3-.55-3.6-1.5-7.05-2.4-.35-4.75-.65.9 3.55 1.4 7.4m-.9.95q-3.3-.2-6.55-.35.35 3.75.35 7.7h6.6q0-3.75-.4-7.35m-8.1-10.25q3.1.35 6.3.75-1.05-3.55-2.45-6.9-3-.4-5.9-.8 1.15 3.35 2.05 6.95M96.1 28.3l-.05-.05h-.1q-2-.4-4-.75 1.45 3.2 2.45 6.65 2.05.25 4.15.65h.2q-1.1-3.35-2.65-6.5m-7.55-5.15Q87.4 21.2 86.1 19.4q-2-.45-4-.85 1.4 2.2 2.6 4.6.6 1.15 1.1 2.3 2.2.3 4.4.7-.8-1.55-1.65-3m-4.1-10.1V13q-1.75-.65-3.55-1.2 1.15 1.1 2.2 2.3 1.95 2.1 3.6 4.4 1.9.45 3.8.95-1.95-2.45-4.25-4.85-.8-.75-1.6-1.45l-.1-.05q-.05-.05-.1-.05z" />
                    <path
                        fillOpacity={0.8}
                        d="M60.85 77.15q.6-3.75 1.05-7.9-5.5.25-10.9.25v7.9q4.95-.05 9.85-.25m6.2 7.6q1.5-3.45 2.6-7.15-4 .35-7.95.5-.6 3.75-1.45 7.25 3.4-.25 6.8-.6M44.85 95.3q1.1 2.25 2.25 3.6 1.25 1.45 2.55 1.8.05 0 .1.05H50v-5.3q-2.55-.05-5.15-.15M30.2 77.5q-3.35-.3-6.7-.75 1.45 3.75 3.4 7.2 2.9.4 5.85.75-1.45-3.45-2.55-7.2m-15.95 5q-1.7-.35-3.4-.8 1.8 2.25 3.9 4.35 1.05 1.05 2 1.95.2.1.35.15 1.5.55 3 1.05-1.25-1.2-2.45-2.5-1.8-2-3.4-4.2m-2.2-16q-.9-3.5-1.35-7.2-2.5-.15-4.95-.3.5 3.55 1.45 6.95 2.4.25 4.85.55M.65 58.7H.6q.5 3.35 1.5 6.6h.05l4 .5q-.95-3.3-1.4-6.85-1.55-.05-3.05-.2h-.05q-.5-.05-1-.05m36.7 1.55l-9.2-.2q.3 4.05.95 7.85 4.4.25 8.85.4-.35-3.9-.6-8.05M18.25 42.3q-3.35.15-6.7.4-.4 3.6-.4 7.35h6.75q0-3.95.35-7.75m-4.85-9.1q3.2-.4 6.45-.75.85-3.6 2.05-7-3.1.35-6.1.85-1.45 3.35-2.4 6.9M23.9 9.45q1.5-.4 2.95-.8 3.45-3.25 7.3-5.45Q28.7 5.5 23.9 9.45M37.3 7.5q-2.1.35-4.2.75-2.55 2.75-4.9 6.4l-.8 1.4q2.8-.4 5.65-.7.3-.6.55-1.15 1.75-3.85 3.7-6.7m35.6 34.4q-4.65-.15-9.4-.3.2 4.15.2 8.45h9.5q0-4.15-.3-8.15m-.25-10.25q3.8.3 7.5.7-.8-3.65-2.05-7.05-3.5-.4-7.05-.75.95 3.45 1.6 7.1M50 40.5v-8.7q-5.55 0-11.05.2-.4 4.1-.6 8.6 5.85-.1 11.65-.1M51 .05v5.5q2.55 0 5.1.2Q53.75.6 51 .05M81.45 83.6q-.15 0-.3.05-1 1.5-2.2 3.05-1.8 2.35-3.75 4.35 1.6-.5 3.15-.95 1.6-1.4 3.1-3.05l.9-1q1.4-1.55 2.65-3.2-1.75.4-3.55.75m-.2-15.45q-.1.45-.2.85-.85 3.45-2 6.6l2.4-.3q1.8-.25 3.5-.5 1.5-3.5 2.6-7.2-3.15.3-6.3.55m7.95-8.8q-3.25.15-6.5.35-.45 3.85-1.2 7.5 3.15-.3 6.3-.65.9-3.5 1.4-7.2M84.65 25.3q-.55-1.15-1-2.15-1.35-2.55-2.9-4.9l-5.2-.9q1.5 2.8 2.7 5.8.3.6.55 1.3 2.9.35 5.85.85M95.2 43.1q-2.4-.2-4.85-.35.4 3.55.4 7.3h4.9q0-3.55-.45-6.95m3.95-6.7q0-.3-.1-.5-.1-.05-.2-.05-2.1-.35-4.15-.7.9 3.4 1.35 7 2.15.15 4.25.3h.15q-.5-3.1-1.3-6.05z"
                    />
                    <path
                        fillOpacity={0.4}
                        d="M68.25 93.7q-3.15 3.25-6.55 5.15 5.35-2 9.95-5.9-1.7.4-3.4.75m4.6-7.6q.35-.6.7-1.15-2.95.45-5.8.75-.2.45-.4.85-1.85 4-3.85 6.95 2.1-.3 4.25-.7 2.65-2.9 5.1-6.7m-42.5 10.75q-4.5-2.45-8.55-6.05-1.45-.5-2.8-.95 4.1 3.35 8.65 5.7 1.35.7 2.7 1.3M15.2 75.65q-2.25-.35-4.5-.75 1.75 3.5 4.1 6.75 2.1.45 4.15.85-2.15-3.3-3.75-6.85m23.15-15.4q.2 4.2.6 8.1 5.5.15 11.05.15v-8.15l-11.65-.1M27.05 41.9q-3.95.1-7.8.35-.35 3.8-.4 7.8h7.9q0-4.15.3-8.15M.4 43.5v.15q-.35 3.05-.4 6.2v.2h4.15q0-3.5.4-6.9-2.05.15-4.1.35H.4m30.8-20.1q2-.1 4-.25t3.95-.2q.6-3.85 1.45-7.25-3.4.15-6.8.55-1.4 3.25-2.5 6.9-.05.15-.1.25M34.3 7q1.9-.3 3.8-.65 2.4-3.3 5.2-5.15-4.75 1.75-9 5.8m32.4 8.15q-.1-.25-.3-.55-1.9-4.25-4.1-7.2-2.35-.3-4.7-.55 1.25 3.1 2.3 7.45.05.15.15.35 3.35.2 6.65.5M70.1 3.6q-.6-.2-1.15-.45 5.45 2.7 10.3 7.1 1.65.45 3.35 1.1-4.05-3.4-8.4-5.8-2.05-1.05-4.1-1.95m11.65 55.1q.35-3.7.4-7.65H74.2q0 4.1-.35 7.9 3.95-.05 7.9-.25m1.05-.05q3.25-.15 6.55-.3.4-3.55.4-7.3h-6.6q-.05 3.95-.35 7.6m17.85-15q-.05-.1-.05-.15-.1 0-.2-.05-2.05-.15-4.15-.3.4 3.4.4 6.9H101q0-3.3-.35-6.4z"
                    />
                    <path
                        fillOpacity={0.6}
                        d="M66.5 94q-1.9.35-3.8.6-2 2.65-4.1 4.3-.55.4-1.05.7.95-.3 1.85-.7 3.7-1.7 7.1-4.9m-16.5.45v-7.8q-4 0-8.1-.25 1.2 4.65 2.55 7.85 2.8.2 5.55.2m12.55-35.2q0-.15.05-.3.1-3.8.1-7.9H51v8.3q5.75 0 11.55-.1M39.4 98.9q-3.45-1.95-6.55-5.2-1.85-.35-3.65-.8 4.7 4 10.15 6 .1.05.25.1l-.2-.1m-5.05-13.05q.1.1.15.3 2.05 4.45 4.3 7.55 2.25.3 4.5.5-1.2-3.2-2.4-7.7v-.15q-3.3-.2-6.55-.5M20 69l-.2-.8-6.4-.6.4 1.4q.9 3 2.15 5.8l6 .8Q20.85 72.45 20 69m18-36.95q-4.45.2-8.85.55-.7 3.95-1.05 8.25l9.25-.2q.25-4.5.65-8.6m-30.8 3q-1.05 3.4-1.55 7 2.5-.15 5.05-.3.45-3.85 1.35-7.35-2.45.3-4.85.65m5.1-1.75q.95-3.5 2.35-6.8-2.3.4-4.65.8-1.5 3.2-2.55 6.7 2.45-.4 4.85-.7m4.05-20.15l-.3.25q-.1 0-.1.1l-1.2 1.1q-2.2 2.3-4.1 4.65-.1.1-.15.2l3.5-.9q1.7-2.3 3.65-4.45 1.1-1.15 2.1-2.25-1.7.6-3.4 1.3M60.7 22.9q-.6-3.85-1.45-7.3-4.1-.25-8.25-.25v7.25q4.85 0 9.7.3M50 6.55q-2.8 0-5.65.15-1.3 3.15-2.45 7.85v.05q4.05-.25 8.1-.25v-7.8m40.15 75.1q-.15.05-.3.15-1.7.4-3.4.75-1.55 2.15-3.35 4.15-.8.9-1.65 1.75-.45.45-.9.85.45-.15.9-.25 1.05-.4 2.25-.8.05-.1.2-.1l.3-.15q1.05-.9 2.05-1.95 2.1-2.1 3.9-4.4m-8.2.85q1.95-.4 3.95-.85 2.35-3.2 4.15-6.7-2.25.4-4.4.7-1.55 3.55-3.7 6.85m18.4-23.55q0-.1.05-.25h-.2q-2.05.15-4.15.25-.5 3.55-1.4 6.85 2-.25 4.1-.5h.15q.95-3.1 1.45-6.35M86.25 26.5q1.4 3.3 2.35 6.8 2.35.3 4.7.7-1-3.5-2.55-6.7l-4.5-.8m-1-8.35q-1.35-1.75-2.9-3.4-1.8-2-3.6-3.7l-3.2-.9q1.75 1.8 3.4 3.95 1.25 1.65 2.35 3.3 2 .4 3.95.75z"
                    />
                    <path
                        fillOpacity={0.2}
                        d="M57.1 95.2q-.95 2.2-2 3.7-.6.8-1.2 1.35 1.5-.5 2.9-1.35 2.35-1.5 4.5-4.1-2.15.2-4.2.4m-11.3 3.7q-1.05-1.5-2.05-3.7l-4.1-.4q2.1 2.6 4.45 4.1 1.4.85 2.85 1.35-.55-.55-1.15-1.35M33.6 86.55q-.2-.4-.35-.8-2.9-.35-5.75-.75l.7 1.1q2.4 3.85 5.15 6.7 2.05.4 4.05.7-2-2.95-3.8-6.95M2.5 66.35h-.05q.4 1.35.95 2.65.75 1.95 1.7 3.85h.1q1.9.4 3.75.75-1-2.25-1.8-4.6-.35-1.1-.7-2.15-2-.3-3.95-.5m15.4-15.3h-6.75q0 3.75.45 7.3 3.3.15 6.7.3-.35-3.65-.4-7.6M29.25 68.9q0 .05.05.1.65 3.85 1.7 7.55 4 .35 8.05.6-.6-3.8-1-7.9-3.45-.05-6.8-.25-1.05-.05-2-.1m8.1-27.3q-4.7.1-9.35.3-.25 4-.25 8.15h9.45q0-4.3.15-8.45M14.6 19.45q-1.3 1.8-2.35 3.7-.95 1.45-1.7 3 2.25-.4 4.6-.75.45-1.15 1.05-2.25 1.15-2.35 2.55-4.6-2.05.45-4.15.9M51 31.8v8.7q5.75 0 11.5.15-.2-4.5-.6-8.65-5.5-.2-10.9-.2M49.95 0q-2.8.6-5.15 5.7 2.6-.15 5.2-.15V0h-.05m30 17.1q-.8-1.2-1.8-2.4Q76 11.85 73.6 9.6q-1.95-.55-3.95-.95 2.1 2.4 4.05 5.5.6 1 1.25 2.1 2.45.35 5 .85M70 24.5q-4.05-.35-8.1-.55.55 3.4.9 7.1 4.4.2 8.85.55-.7-3.7-1.65-7.1M62.9 6.45q1.95.25 3.9.65-4.3-4.25-9.25-5.95 2.8 1.85 5.35 5.3m38.1 44.6h-4.35q-.05 3.55-.45 6.9 2.05-.15 4.15-.25h.2q.4-3.25.45-6.65m-13.2-16.9q-3.2-.4-6.35-.75.8 3.85 1.25 7.95 3.25.15 6.55.35-.5-3.85-1.45-7.55z"
                    />
                </g>
                <g id="ObjMor106__Layer1_0_MEMBER_0_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_37)"
                        d="M293.6 45.9l1.9-1.9-8.5-6.2-6.65-6.65-.75.75 14 14z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_38)"
                        d="M285.35 39.45l6.35 8.35 1.9-1.9-14-14-.9.9 6.65 6.65z"
                    />
                </g>
                <g id="ObjMor106__Layer1_0_MEMBER_1_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_39)"
                        d="M299.95 37.55l-8.35 6.35 1.9 1.9 14-14-.9-.9-6.65 6.65z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_40)"
                        d="M293.5 45.8l1.9 1.9 6.15-8.55 6.65-6.65-.7-.7-14 14z"
                    />
                </g>
                <g id="ObjMor106__Layer1_0_MEMBER_2_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_41)"
                        d="M295.95 44.4l-1.9 1.9 14 14 .9-.9-6.65-6.65-6.35-8.35z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_42)"
                        d="M294.05 46.3l-1.9 1.9 8.55 6.15 6.65 6.65.7-.7-14-14z"
                    />
                </g>
                <g id="ObjMor106__Layer1_0_MEMBER_3_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_43)"
                        d="M293 46.25l-1.9-1.9-6.3 8.6-6.7 6.7.75.75L293 46.25z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_44)"
                        d="M294.9 48.15l-1.9-1.9-14.15 14.15.9.9 6.7-6.7 8.45-6.45z"
                    />
                </g>
                <g id="ObjMor106__Layer1_1_MEMBER_0_MEMBER_0_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_46)"
                        d="M363.4 72.85l-11.6-11.6-.75.7 5.55 5.55 5.25 6.95 1.55-1.6z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_47)"
                        d="M351.8 61.25l11.6 11.6 1.6-1.6-7.1-5.1-5.5-5.55-.6.65z"
                    />
                </g>
                <g id="ObjMor106__Layer1_1_MEMBER_0_MEMBER_1_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_48)"
                        d="M364.9 74.4l5.15-7.1 5.55-5.55-.6-.6-11.7 11.65 1.6 1.6z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_49)"
                        d="M361.75 71.25l1.55 1.55L375 61.15l-.75-.75-5.55 5.5-6.95 5.35z"
                    />
                </g>
                <g id="ObjMor106__Layer1_1_MEMBER_0_MEMBER_2_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_50)"
                        d="M375.4 84.85l.75-.75-5.5-5.55-5.3-6.9-1.55 1.55 11.6 11.65z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_51)"
                        d="M363.8 73.2l-1.6 1.6 7.05 5.1 5.55 5.55.6-.6-11.6-11.65z"
                    />
                </g>
                <g id="ObjMor106__Layer1_1_MEMBER_0_MEMBER_3_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_52)"
                        d="M351.15 84.95L362.9 73.2l-1.55-1.55-5.2 7.1-5.6 5.6.6.6z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_53)"
                        d="M362.9 73.2l-11.75 11.75.8.75 5.55-5.55 7-5.35-1.6-1.6z"
                    />
                </g>
                <g id="ObjMor106__Layer1_1_MEMBER_1_MEMBER_0_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_55)"
                        d="M363.2 72.8l.05-16.45h-1.1l.05 7.85-1.2 8.6h2.2z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_56)"
                        d="M364.1 64.1v-7.8l-.85.05-.05 16.45h2.3l-1.4-8.7z"
                    />
                </g>
                <g id="ObjMor106__Layer1_1_MEMBER_1_MEMBER_1_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_57)"
                        d="M363.15 70.45l.05 2.25h16.5v-1.1l-7.85.05-8.7-1.2z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_58)"
                        d="M363.2 72.7v2.2l8.65-1.35 7.85-.05v-.8h-16.5z"
                    />
                </g>
                <g id="ObjMor106__Layer1_1_MEMBER_1_MEMBER_2_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_59)"
                        d="M363.2 89.7V73.3H361l1.4 8.6v7.8h.8z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_60)"
                        d="M363.2 89.7h1.1v-7.8l1.2-8.6h-2.3v16.4z"
                    />
                </g>
                <g id="ObjMor106__Layer1_1_MEMBER_1_MEMBER_3_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_61)"
                        d="M362.65 72.65h-16.6v1.1l7.85-.05 8.75 1.25v-2.3z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_62)"
                        d="M362.65 72.65v-2.2l-8.75 1.35H346l.05.85h16.6z"
                    />
                </g>
                <g id="ObjMor106__Layer1_2_MEMBER_0_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_64)"
                        d="M296.9 80.05v1.2h9.5l10.45 1.45V80l-19.95.05z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_65)"
                        d="M296.9 78.95v1.1l19.95-.05v-2.7l-10.45 1.65h-9.5z"
                    />
                </g>
                <g id="ObjMor106__Layer1_2_MEMBER_1_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_66)"
                        d="M317.75 69.5V60h-1l-.05 20.05h2.8l-1.75-10.55z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_67)"
                        d="M316.75 60h-1.3v9.5L314 80.05h2.7l.05-20.05z"
                    />
                </g>
                <g id="ObjMor106__Layer1_2_MEMBER_2_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_68)"
                        d="M337.45 80v-1.3h-9.5l-10.45-1.45-.05 2.75h20z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_69)"
                        d="M328 81.05h9.4l.05-1.05h-20v2.7L328 81.05z"
                    />
                </g>
                <g id="ObjMor106__Layer1_2_MEMBER_3_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_70)"
                        d="M316.7 80.75H314l1.7 10.6-.05 9.55h1.1l-.05-20.15z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_71)"
                        d="M318 91.35l1.45-10.65-2.75.05.05 20.15h1.3l-.05-9.55z"
                    />
                </g>
                <g id="ObjMor106__Layer1_3_MEMBER_0_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_73)"
                        d="M365.2 37.1v-2.4l-17.75.05v1.05h8.45l9.3 1.3z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_74)"
                        d="M365.2 34.7v-2.4l-9.3 1.45h-8.45v1l17.75-.05z"
                    />
                </g>
                <g id="ObjMor106__Layer1_3_MEMBER_1_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_75)"
                        d="M365.05 34.75l.05-17.8h-1.15v8.4l-1.3 9.4h2.4z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_76)"
                        d="M365.1 16.95l-.05 17.8h2.5l-1.55-9.4v-8.4h-.9z"
                    />
                </g>
                <g id="ObjMor106__Layer1_3_MEMBER_2_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_77)"
                        d="M375.1 35.65h8.35l.05-.95h-17.8v2.4l9.4-1.45z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_78)"
                        d="M383.5 34.7v-1.15h-8.45l-9.3-1.3-.05 2.45h17.8z"
                    />
                </g>
                <g id="ObjMor106__Layer1_3_MEMBER_3_FILL">
                    <path
                        fill="url(#ObjMor106__Gradient_79)"
                        d="M362.65 35.35l1.5 9.4-.05 8.5h1l-.05-17.9h-2.4z"
                    />
                    <path
                        fill="url(#ObjMor106__Gradient_80)"
                        d="M366.2 44.75l1.3-9.45-2.45.05.05 17.9h1.15l-.05-8.5z"
                    />
                </g>
                <path
                    fill="url(#ObjMor106__Gradient_9)"
                    d="M292.05 103.55q.9-.85.9-2.2 0-1.25-.9-2.2-.95-.85-2.2-.9-1.3.05-2.2.95-.95.9-.95 2.15 0 1.3.95 2.2.9.9 2.15.9 1.3.1 2.25-.9z"
                    id="ObjMor106__Layer10_0_MEMBER_0_MEMBER_4_FILL"
                />
                <path
                    fill="url(#ObjMor106__Gradient_18)"
                    d="M291.8 103.4q.9-.9.9-2.15t-.85-2.2q-.95-.9-2.2-.9-1.35 0-2.2.9-.9.9-.9 2.25 0 1.25.85 2.1.9 1 2.2 1 1.25 0 2.2-1z"
                    id="ObjMor106__Layer10_0_MEMBER_1_MEMBER_4_FILL"
                />
                <path
                    fill="url(#ObjMor106__Gradient_27)"
                    d="M345 24.85q1.25.25 2.35-.5 1-.65 1.25-1.95.2-1.2-.45-2.25-.75-1.05-1.95-1.3-1.25-.2-2.3.5-1.05.7-1.25 1.9-.25 1.25.5 2.3.65 1.05 1.85 1.3z"
                    id="ObjMor106__Layer10_1_MEMBER_0_MEMBER_4_FILL"
                />
                <path
                    fill="url(#ObjMor106__Gradient_36)"
                    d="M344.85 24.7q1.25.25 2.25-.55 1.05-.7 1.3-1.9t-.45-2.3q-.75-.95-1.95-1.2-1.3-.25-2.25.4-1 .75-1.25 2t.4 2.2q.7 1.1 1.95 1.35z"
                    id="ObjMor106__Layer10_1_MEMBER_1_MEMBER_4_FILL"
                />
                <path
                    d="M325.4-154.65h-2.45V9h-4q-4.95.25-5.05 4.6v3.35h20.8V13.6q-.1-4.35-5.05-4.6h-4.25v-163.65z"
                    id="ObjMor106__Layer10_2_FILL"
                />
                <path
                    fill={colors.col1n}
                    d="M93.15 21.15q0-.05-.05-.05-2.35-3.1-5.2-6l-1.6-1.6-.05-.1q-5.05-4.5-10.6-7.55-2.05-1.1-4.15-2Q62.3 0 51.5 0 38.2 0 27.35 5.85 21.7 8.9 16.8 13.45q0 .05-.05.05l-1.7 1.6Q12.2 18 9.8 21.15v.05q-1.15 1.55-2.1 3.1-.9 1.35-1.65 2.75-.45.8-.9 1.7l-.05.05v.05q-1.8 3.6-2.95 7.5-.05.05-.05.1-.05.3-.2.6v.05q-.15.1-.15.3 0 .1.05.2-.85 3-1.3 6.2v.35Q0 47.45 0 51v.75q0 3.85.5 7.55 0 .05.05.15.55 3.9 1.75 7.55.5 1.75 1.15 3.45.85 2.15 1.9 4.2v.05q2.05 3.95 4.8 7.55v.05q.05 0 .05.05 2.2 2.9 4.85 5.55l2.15 2.05h.05q5.1 4.65 10.95 7.65 2.7 1.35 5.6 2.45Q42 103 51.5 103q9.45 0 17.75-2.95 1.15-.4 2.25-.9 1.65-.7 3.3-1.55 4-2.05 7.65-4.85 1.7-1.35 3.35-2.8 1.05-1 2.1-2.05 2.7-2.65 4.9-5.55 0-.05.05-.05 2.8-3.65 4.8-7.6v-.05h.05q1.85-3.65 3.1-7.6V67q.95-3.3 1.55-6.9.05-.3.1-.65v-.05q0-.05.05-.05v-.05q.45-3.7.5-7.55v-.05-.2q0-3.75-.5-7.35v-.05-.1-.2q-.5-3.4-1.35-6.55-.15-.4-.2-.75v-.05l-.05-.05q-1.2-3.95-3-7.55h-.05v-.1q-1.15-2.3-2.5-4.45-1.05-1.6-2.2-3.15m-7.7-6.95v-.05l.1.1q-.053-.05-.1-.05M32 4.7q-.1.05-.1.1-2.15.9-4.15 1.95l.05-.05q2.1-1.05 4.2-2m-12.55 7.75h-.05q.55-.5 1.1-.9-.5.45-1.05.9z"
                    id="ObjMor106__Symbol_270_0_Layer0_0_FILL"
                />
                <path
                    fill="url(#ObjMor106__Gradient_45)"
                    d="M293.7 49.45q1.55-.05 2.6-1.1 1.1-1.1 1.15-2.65 0-1.5-1.1-2.6t-2.65-1.15q-1.55.05-2.65 1.15-1.05 1.05-1.1 2.6.05 1.55 1.15 2.65 1.1 1.1 2.6 1.1z"
                    id="ObjMor106__Layer1_0_MEMBER_4_FILL"
                />
                <path
                    fill="url(#ObjMor106__Gradient_54)"
                    d="M360.5 72.8q0 1.25.9 2.15.9.9 2.15.9 1.25.05 2.2-.85.9-.9.9-2.2 0-1.3-.9-2.2-.95-.9-2.2-.9-1.25.05-2.15.95-.9.9-.9 2.15z"
                    id="ObjMor106__Layer1_1_MEMBER_0_MEMBER_4_FILL"
                />
                <path
                    fill="url(#ObjMor106__Gradient_63)"
                    d="M360.35 72.85q-.05 1.25.85 2.15.9.9 2.2.9 1.25.05 2.2-.9.85-.85.85-2.15 0-1.3-.9-2.2-.95-.85-2.15-.85-1.3 0-2.15.85-.95.95-.9 2.2z"
                    id="ObjMor106__Layer1_1_MEMBER_1_MEMBER_4_FILL"
                />
                <path
                    fill="url(#ObjMor106__Gradient_72)"
                    d="M320.7 79.85q-.05-1.55-1.15-2.65-1.1-1.1-2.6-1.1-1.6 0-2.65 1.05-1.05 1.15-1.1 2.7.05 1.55 1.1 2.6 1.1 1.1 2.6 1.1 1.6 0 2.65-1.05 1.1-1.1 1.15-2.65z"
                    id="ObjMor106__Layer1_2_MEMBER_4_FILL"
                />
                <path
                    fill="url(#ObjMor106__Gradient_81)"
                    d="M368.6 34.55q-.05-1.35-1-2.35-1-.95-2.35-.95-1.4 0-2.35.9-.9 1.05-.95 2.4.05 1.4.95 2.3 1 1 2.35 1 1.4 0 2.35-.95.95-.95 1-2.35z"
                    id="ObjMor106__Layer1_3_MEMBER_4_FILL"
                />
                <radialGradient
                    id="ObjMor106__Gradient_9"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={3.2}
                    fx={0}
                    fy={0}
                    gradientTransform="rotate(-45 267.18 -299.17)"
                    spreadMethod="pad"
                >
                    <stop offset="34.118%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </radialGradient>
                <radialGradient
                    id="ObjMor106__Gradient_18"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={3.2}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(289.6 101.2)"
                    spreadMethod="pad"
                >
                    <stop offset="34.118%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </radialGradient>
                <radialGradient
                    id="ObjMor106__Gradient_27"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={3.12}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(.8252 -.56483 .56082 .82921 345.6 21.8)"
                    spreadMethod="pad"
                >
                    <stop offset="34.118%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </radialGradient>
                <radialGradient
                    id="ObjMor106__Gradient_36"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={3.116}
                    fx={0}
                    fy={0}
                    gradientTransform="matrix(.98283 .18453 -.18453 .98684 345.4 21.65)"
                    spreadMethod="pad"
                >
                    <stop offset="34.118%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </radialGradient>
                <radialGradient
                    id="ObjMor106__Gradient_45"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={3.818}
                    fx={0}
                    fy={0}
                    gradientTransform="rotate(-45 201.99 -331.617)"
                    spreadMethod="pad"
                >
                    <stop offset="34.118%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </radialGradient>
                <radialGradient
                    id="ObjMor106__Gradient_54"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={3.164}
                    fx={0}
                    fy={0}
                    gradientTransform="rotate(-45 269.567 -402.408)"
                    spreadMethod="pad"
                >
                    <stop offset="34.118%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </radialGradient>
                <radialGradient
                    id="ObjMor106__Gradient_63"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={3.163}
                    fx={0}
                    fy={0}
                    gradientTransform="translate(363.35 72.75)"
                    spreadMethod="pad"
                >
                    <stop offset="34.118%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </radialGradient>
                <radialGradient
                    id="ObjMor106__Gradient_72"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={3.862}
                    fx={0}
                    fy={0}
                    gradientTransform="rotate(-90 198.325 -118.575)"
                    spreadMethod="pad"
                >
                    <stop offset="34.118%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </radialGradient>
                <radialGradient
                    id="ObjMor106__Gradient_81"
                    gradientUnits="userSpaceOnUse"
                    cx={0}
                    cy={0}
                    r={3.425}
                    fx={0}
                    fy={0}
                    gradientTransform="rotate(-90 199.825 -165.375)"
                    spreadMethod="pad"
                >
                    <stop offset="34.118%" stopColor="#FFF" />
                    <stop offset="100%" stopColor="#FFF" stopOpacity={0} />
                </radialGradient>
            </defs>
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_0_MEMBER_0_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_0_MEMBER_1_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_0_MEMBER_2_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_0_MEMBER_3_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_0_MEMBER_4_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_1_MEMBER_0_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_1_MEMBER_1_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_1_MEMBER_2_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_1_MEMBER_3_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_0_MEMBER_1_MEMBER_4_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_0_MEMBER_0_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_0_MEMBER_1_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_0_MEMBER_2_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_0_MEMBER_3_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_0_MEMBER_4_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_1_MEMBER_0_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_1_MEMBER_1_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_1_MEMBER_2_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_1_MEMBER_3_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_1_MEMBER_1_MEMBER_4_FILL"
                transform="matrix(1.02556 0 0 1.02556 -6.65 -7.05)"
            />
            <use
                xlinkHref="#ObjMor106__Layer10_2_FILL"
                transform="matrix(1.02563 0 0 1.02563 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Symbol_270_0_Layer0_0_FILL"
                transform="matrix(1.02563 0 0 1.02563 273.9 7.5)"
                id="ObjMor106__col1n"
            />
            <use
                xlinkHref="#ObjMor106__Symbol_271_0_Layer0_0_FILL"
                transform="matrix(1.02563 0 0 1.02563 274.9 8.7)"
                id="ObjMor106__col2n"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_0_MEMBER_0_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_0_MEMBER_1_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_0_MEMBER_2_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_0_MEMBER_3_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_0_MEMBER_4_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_0_MEMBER_0_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_0_MEMBER_1_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_0_MEMBER_2_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_0_MEMBER_3_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_0_MEMBER_4_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_1_MEMBER_0_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_1_MEMBER_1_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_1_MEMBER_2_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_1_MEMBER_3_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_1_MEMBER_1_MEMBER_4_FILL"
                transform="matrix(1.02556 0 0 1.02556 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_2_MEMBER_0_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_2_MEMBER_1_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_2_MEMBER_2_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_2_MEMBER_3_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_2_MEMBER_4_FILL"
                transform="matrix(1.02559 0 0 1.02559 -5.75 -5.3)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_3_MEMBER_0_FILL"
                transform="matrix(.86826 0 0 .86826 50.2 .65)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_3_MEMBER_1_FILL"
                transform="matrix(.86826 0 0 .86826 50.2 .65)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_3_MEMBER_2_FILL"
                transform="matrix(.86826 0 0 .86826 50.2 .65)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_3_MEMBER_3_FILL"
                transform="matrix(.86826 0 0 .86826 50.2 .65)"
            />
            <use
                xlinkHref="#ObjMor106__Layer1_3_MEMBER_4_FILL"
                transform="matrix(.86826 0 0 .86826 50.2 .65)"
            />
        </g></g>
    )
}
export default ObjMor106
